/**
 * Authorization Roles
 */
export const authRoles = {
    dev             : ['dev'],
    admin           : ['dev','admin'],
    company         : ['dev','admin', 'company'],
    instructor      : ['dev','admin', 'company', 'instructor'],
    student         : ['dev','admin', 'company', 'instructor', 'student'],
    user            : ['dev','admin', 'company', 'user', 'instructor', 'student'],
    onlyGuest       : ['guest'],
    onlyStudent     : ['student'],
};


// WEBPACK FOOTER //
// src/auth/auth.js